module.exports = __webpack_public_path__ + "static/wl-icons-light-8e091e9081ac9157a5593d344d55a8fa.png";